<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg p-6 w-3/4 max-w-4xl">
      <h3 class="text-lg font-semibold mb-2">FHIR Bundle:</h3>
      <div class="bg-gray-100 rounded p-4 h-96 overflow-auto relative">
        <pre class="text-sm whitespace-pre-wrap">{{ bundle.bundle }}</pre>
        <button @click="copyToClipboard(JSON.stringify(bundle.bundle))" class="absolute top-2 right-2 bg-blue-500 text-white px-2 py-1 rounded text-xs">
          Kopieren
        </button>
      </div>
      <div class="mt-4">
        <h4 class="text-md font-semibold mb-2">Create Task Response:</h4>
        <div class="bg-gray-100 rounded p-2 relative">
          <pre class="text-sm whitespace-pre-wrap">{{ JSON.stringify(createTaskResponse, null, 2) }}</pre>
          <button @click="copyToClipboard(JSON.stringify(createTaskResponse))" class="absolute top-2 right-2 bg-blue-500 text-white px-2 py-1 rounded text-xs">
            Kopieren
          </button>
        </div>
      </div>
      <div class="mt-4 flex justify-end space-x-2">
        <button @click="$emit('einstellen')" class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
          E-Rezept einstellen
        </button>
        <button @click="$emit('close')" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          Schließen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BundleModal',
  props: ['bundle', 'createTaskResponse'],
  emits: ['close', 'einstellen'],
  setup() {
    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
        alert('In die Zwischenablage kopiert!');
      }).catch(err => {
        console.error('Fehler beim Kopieren: ', err);
      });
    };

    return {
      copyToClipboard
    };
  }
};
</script>